<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
  >
    <path
      fill="#4f2b1b"
      d="M72.59,24.86c-7.19-6.09-16.66-9.57-26.95-8.95-18.92,1.15-34.32,16.4-35.63,35.31-1.53,22.25,16.06,40.78,37.99,40.78s38.08-17.05,38.08-38.08c0-2.44-.24-4.82-.68-7.12-.8,.8-1.92,1.31-3.38,1.31-.16,0-.31-.01-.46-.02,.33,1.9,.52,3.84,.52,5.83,0,19.6-16.63,35.39-36.52,34-16.79-1.17-30.39-14.77-31.56-31.56-1.39-19.89,14.4-36.52,34-36.52,5.99,0,11.62,1.56,16.52,4.29l2.53-.09c.63-.02,1.27,.02,1.89,.14l3.65,.69Z"
    />
    <path
      fill="#85c441"
      d="M48.01,13.5c-3.43-2-7.04-.75-10.43,.55-1.82-3.01-3.95-5.7-7.77-6.16-3.44-.42-6.79,1.4-8.5,4.39-2.29,4.01-.86,9.07,.86,13.01,1.4,3.22,4.79,10.63,8.45,11.63,3.53,.96,9.95-2.93,12.92-4.62,3.51-2.01,7.82-5.46,8.58-9.7,.61-3.41-1.1-7.34-4.11-9.09Z"
    />
    <g>
      <circle
        fill="#4f2b1b"
        cx="30.39"
        cy="60.96"
        r="1.99"
      />
      <circle
        fill="#4f2b1b"
        cx="39.86"
        cy="60.54"
        r="1.99"
      />
      <path
        fill="#4f2b1b"
        d="M53.6,57.7c-.12-1.19-.69-2.27-1.62-3.03-.85-.7-1.9-1.05-2.97-1.02-1.92-4.51-5.96-7.75-10.65-8.76,.86-.84,.05-2.79-1.53-2.55-.92,.14-1.79,.47-2.48,.99-1.92-1.31-5.11-1.24-7.13-1.07-1.91,.16-1.93,3.16,0,3,.73-.06,2.4-.26,3.76-.08-5.18,1.56-9.22,5.88-10.35,11.23-1.07,.18-2.03,.73-2.72,1.58-.76,.93-1.12,2.09-1,3.29,.12,1.19,.69,2.27,1.62,3.03,.85,.69,1.9,1.04,2.98,1.02,2.33,5.49,7.81,9.1,13.77,9.1,.47,0,.95-.02,1.43-.07,6.5-.63,11.84-5.51,13.17-11.8,2.3-.39,3.95-2.5,3.72-4.86Zm-4.32,1.92c-.11,0-.24,0-.41-.03l-1.57-.28-.19,1.59c-.65,5.54-5.15,9.95-10.7,10.49-5.55,.55-10.82-2.92-12.53-8.22l-.49-1.52-1.49,.58c-.16,.06-.28,.1-.39,.11-.82,.09-1.55-.52-1.63-1.34-.08-.82,.52-1.55,1.34-1.63,.1-.01,.24,0,.41,.03l1.57,.28,.19-1.59c.65-5.54,5.15-9.95,10.7-10.49,5.56-.55,10.82,2.92,12.53,8.22l.49,1.52,1.49-.58c.16-.06,.28-.1,.39-.11h0c.4-.04,.78,.08,1.09,.33,.31,.25,.5,.61,.54,1,.08,.82-.52,1.55-1.34,1.62Z"
      />
    </g>
    <circle
      fill="#4f2b1b"
      cx="72.53"
      cy="40.32"
      r="1.99"
    />
    <circle
      fill="#4f2b1b"
      cx="63.26"
      cy="38.34"
      r="1.99"
    />
    <path
      fill="#4f2b1b"
      d="M67.49,25.58c.77,0,1.54,.06,2.31,.18,6.45,1.03,11.49,6.21,12.43,12.58,2.28,.53,3.79,2.74,3.42,5.08-.19,1.18-.83,2.22-1.8,2.93-.89,.64-1.94,.94-3.03,.84-2.87,5.76-11.28,16.13-17.72,15.1-6.45-1.02-9.49-13.21-10.44-19.58-1.06-.24-1.98-.85-2.62-1.74-.7-.97-.99-2.16-.8-3.34,.19-1.18,.83-2.22,1.8-2.93,.89-.64,1.95-.94,3.03-.84,2.53-5.07,7.79-8.28,13.41-8.28Zm11.98,15.86l-.09-1.6c-.31-5.57-4.54-10.24-10.05-11.12-5.52-.88-10.98,2.26-13,7.45l-.58,1.49-1.45-.67c-.16-.07-.28-.11-.38-.13-.39-.06-.79,.03-1.11,.27-.32,.23-.53,.58-.59,.97s.03,.79,.27,1.11c.23,.32,.58,.53,.97,.59h0c.11,.02,.24,.02,.41,0l1.58-.18,.09,1.59c.31,5.57,2.54,17.24,8.05,18.12,5.51,.88,12.98-9.26,15-14.45l.58-1.49,1.45,.67c.16,.07,.28,.11,.39,.13,.39,.06,.78-.03,1.11-.27,.32-.23,.53-.58,.6-.97,.13-.81-.43-1.57-1.24-1.7-.1-.02-.23-.01-.4,0l-1.59,.19Z"
    />
    <path
      fill="#85c441"
      d="M71.24,62.75c-2.25,.27-6.51,1.44-8.24,1.04h-.02c-1.72-.42-4.98-3.45-6.84-4.73-.26-.17-.5-.15-.7-.03-.18,.07-.34,.22-.4,.48-.55,2.26-1.11,4.51-1.66,6.77-.14,.57,.36,1.05,.92,.92,1.45-.33,2.9-.66,4.34-.99,.91-.21,1.82-.41,2.73-.62,.2-.05,.87-.14,1.2-.24,.23,.2,.63,.47,.75,.58,.75,.69,1.56,1.32,2.33,1.98,1.13,.96,2.26,1.92,3.4,2.88,.41,.35,1.11,.25,1.25-.33,.55-2.26,1.11-4.51,1.66-6.77,.1-.42-.22-1.01-.72-.95Z"
    />
    <path
      fill="#85c441"
      d="M46.93,76.03c-.42-2.29-.85-4.57-1.27-6.86-.09-.48-.71-.68-1.1-.45-1.12,.67-2.24,1.35-3.36,2.02-.89,.54-1.79,1.08-2.68,1.62-.16,.09-.75,.43-.97,.6-.25-.07-.97-.14-1.14-.17-.92-.16-1.84-.33-2.75-.49-1.4-.25-2.79-.5-4.19-.74-.09-.01-.17-.01-.26,0-.15,.02-.28,.09-.39,.18-.15,.12-.25,.29-.27,.49-.02,.09-.01,.18,0,.27,.42,2.28,.84,4.55,1.26,6.83,.08,.44,.73,.72,1.1,.45,1.18-.89,2.37-1.79,3.55-2.68l2.23-1.68c.15-.11,.82-.57,1.05-.8,.25,.1,.86,.21,1.04,.26,.97,.31,1.96,.57,2.94,.85,1.43,.41,2.85,.82,4.28,1.23,.59,.17,1.02-.38,.92-.92Z"
    />
    <path
      fill="#85c441"
      d="M66,49c.3-.09,1-1,2-1,2.42,0,5.26,4.74,6,4l2-2s1,4-3,4-7.15-1.59-7.15-1.59c0,0-3.85,1.59-6.85,1.59s-3-4-3-4c0,0,1,1.33,3,1.66s4-3.66,5-3.66,2,1,2,1Z"
    />
    <path
      fill="#4f2b1b"
      d="M64.71,42.49c-.29,0-.59-.03-.88-.09h0l-3.18-.65c-2.37-.48-3.9-2.8-3.42-5.17l.15-.73c.23-1.15,.9-2.13,1.87-2.78,.98-.65,2.15-.87,3.29-.64l3.18,.65c2.37,.48,3.91,2.8,3.43,5.17l-.15,.73c-.23,1.15-.9,2.13-1.87,2.78-.73,.48-1.56,.73-2.41,.73Zm-.48-2.05c.62,.13,1.26,0,1.79-.35s.89-.89,1.02-1.51l.15-.73c.13-.62,0-1.26-.35-1.79s-.89-.89-1.51-1.02l-3.18-.65c-.63-.13-1.26,0-1.79,.35-.53,.35-.89,.89-1.02,1.51l-.15,.73c-.13,.62,0,1.26,.35,1.79s.89,.89,1.51,1.02l3.18,.65Z"
    />
    <path
      fill="#4f2b1b"
      d="M75.34,44.65c-.29,0-.59-.03-.88-.09l-3.18-.65c-2.37-.48-3.91-2.8-3.43-5.17l.15-.73c.23-1.15,.9-2.13,1.87-2.78,.97-.65,2.14-.87,3.29-.64l3.18,.65c2.37,.48,3.9,2.8,3.42,5.17l-.15,.73c-.23,1.15-.9,2.13-1.87,2.78-.73,.48-1.56,.73-2.41,.73Zm-.48-2.05c.63,.13,1.26,0,1.79-.35,.53-.35,.89-.89,1.02-1.51l.15-.73c.13-.62,0-1.26-.35-1.79s-.89-.89-1.51-1.02l-3.18-.65c-.62-.13-1.26,0-1.79,.35s-.89,.89-1.02,1.51l-.15,.73c-.13,.62,0,1.26,.35,1.79s.89,.89,1.51,1.02l3.18,.65Z"
    />
    <rect
      fill="#4f2b1b"
      x="67.25"
      y="38.08"
      width="2.5"
      height=".83"
      transform="translate(9.02 -12.84) rotate(11.46)"
    />
  </svg>
</template>
